import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
// import { map } from 'rxjs/operators';
import { HttpMethodsService } from '../_helpers/http-methods.service';
import { AssetLibraryConstants } from './constants/asset-library.constant';

@Injectable({
  providedIn: 'root'
})
export class PromoContentService {
  buttonName: string;
  userId = sessionStorage.getItem('userId');
  PROMO_CONTENTS_URL = AssetLibraryConstants.ASSET_LIBRARY_USERS + this.userId
              + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId + AssetLibraryConstants.PROMO_CONTENTS;
              GET_PROMO_CONTENTS_BY_ID_URL = this.PROMO_CONTENTS_URL + AssetLibraryConstants.SLASH;
  GET_PROMO_CONTENT_BY_PAGE_ID_URL = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
              + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId
              + AssetLibraryConstants.PROMO_CONTENTS + AssetLibraryConstants.SLASH;

  constructor(private httpMethodsservice: HttpMethodsService) {

  }

  createPromoContent(configurationsJson: string) {
    const url = this.PROMO_CONTENTS_URL;
    const addObject = {
      configurations: configurationsJson
    };

    return this.httpMethodsservice.post(url, addObject)
      .pipe(map((res: any) =>
        res));
  }

  putPromoContentById(inputJson: string, id: string) {
    const url = this.GET_PROMO_CONTENTS_BY_ID_URL + id;

    return this.httpMethodsservice.put(url, inputJson)
      .pipe(map((res: any) =>
        res));
  }

  getAllPromoContentByUser() {
    const url = this.PROMO_CONTENTS_URL;

    return this.httpMethodsservice.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getPromoContentById(id: string) {
    const url = this.GET_PROMO_CONTENTS_BY_ID_URL + id;

    return this.httpMethodsservice.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getPromoContentByPageId(promoContentId: string, pageId: string) {
    const url = this.GET_PROMO_CONTENT_BY_PAGE_ID_URL
                + promoContentId + AssetLibraryConstants.SLASH + pageId;

    return this.httpMethodsservice.getImage(url, true)
      .pipe(map((res: any) =>
        res));
  }

  putS3PromoContentByPageId(image: File, imageType: string, promoContentId: string, pageId: string) {
    const url = this.GET_PROMO_CONTENT_BY_PAGE_ID_URL
      + promoContentId + AssetLibraryConstants.SLASH + pageId;

    return this.httpMethodsservice.putImage(url, image, imageType, true)
      .pipe(map((res: any) =>
        res));
  }

  deleteS3PromoContentByPageId(promoContentId: string, pageId: string) {
    const url = this.GET_PROMO_CONTENT_BY_PAGE_ID_URL
                + promoContentId + AssetLibraryConstants.SLASH + pageId;

    return this.httpMethodsservice.delete(url, true)
      .pipe(map((res: any) =>
        res));
  }

  deletePromoContentById(promoContentId: string) {
    const url = this.PROMO_CONTENTS_URL
                + AssetLibraryConstants.SLASH + promoContentId;

    return this.httpMethodsservice.delete(url)
      .pipe(map((res: any) =>
        res));
  }
}
